import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AvatarColor } from '../../avatar';
import { getIcon } from '../../icon';
import { TextField } from '../../textfield';
import { measureText, sentence, Typography } from '../../typography';
function renderInput(params, props, additionalProps) {
    const { state, setState, shrink } = additionalProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = props.value;
    const isEmpty = !value || (Array.isArray(value) && !value.length);
    const onMouseDown = props.disableSearch
        ? () => {
            if (state === 'open' && value !== null && value !== undefined) {
                setState('blocked');
            }
        }
        : undefined;
    if (props.renderInput) {
        return props.renderInput({ ...params, onMouseDown });
    }
    const counter = (() => {
        const show = props.multiple &&
            !isEmpty &&
            Boolean(props.multipleConfig?.showCounter);
        const text = show && Array.isArray(value)
            ? `(${value.length}/${props.options.length})`
            : '';
        return {
            show,
            text,
            width: show ? measureText(text, 'caption') : 0
        };
    })();
    const startAdornment = (() => {
        let internalStartAdornment = props.InputProps?.startAdornment;
        if (!props.multiple &&
            value !== undefined &&
            value !== null &&
            (props.getOptionColor || props.getOptionIcon)) {
            if (process.env.NODE_ENV === 'development' &&
                internalStartAdornment) {
                console.warn('[Autocomplete] InputProps.startAdornment will be overridden when providing `getOptionColor` or `getOptionIcon`');
            }
            if (props.getOptionColor) {
                internalStartAdornment = (_jsx(AvatarColor, { sx: { ml: 0.75 }, color: props.getOptionColor(value) }));
            }
            if (props.getOptionIcon) {
                const { icon, iconProps = {} } = props.getOptionIcon(value);
                const Icon = getIcon(icon);
                internalStartAdornment = (_jsx(Icon, { ...iconProps, sx: { ml: 0.75, ...iconProps.sx } }));
            }
        }
        if (params.InputProps.startAdornment || internalStartAdornment) {
            return (_jsxs(_Fragment, { children: [params.InputProps.startAdornment, internalStartAdornment] }));
        }
        return undefined;
    })();
    const endAdornment = (() => {
        const internalEndAdornment = params.InputProps.endAdornment || props.InputProps?.endAdornment ? (_jsxs(_Fragment, { children: [params.InputProps.endAdornment, props.InputProps?.endAdornment] })) : undefined;
        if (!counter.show) {
            return internalEndAdornment;
        }
        return (_jsxs(_Fragment, { children: [_jsx(Typography, { "data-role": "counter", color: "text.secondary", sx: {
                        '.MuiInputBase-root.Mui-focused &, .MuiInputBase-root:hover &': { display: 'block' },
                        display: 'none',
                        pointerEvents: 'none',
                        position: 'absolute',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        right: props.disableClearable ? 32 : 64
                    }, variant: "caption", children: counter.text }), internalEndAdornment] }));
    })();
    const textfieldSlotProps = {
        inputLabel: {
            ...params.InputLabelProps,
            shrink,
            sx: {
                ...(shrink ? { transition: 'none' } : {}),
                maxWidth: 'calc(100% - 52px)'
            }
        },
        input: {
            ...params.InputProps,
            ...props.InputProps,
            startAdornment,
            endAdornment
        },
        htmlInput: params.inputProps
    };
    const paddingRight = props.disableClearable ? 39 : 65;
    return (_jsx(TextField, { ...params, slotProps: textfieldSlotProps, inputRef: props.inputRef, bgColor: props.bgColor, loading: props.loading, skeleton: props.skeleton, readOnly: props.disableSearch, required: props.required, autoFocus: props.autoFocus, placeholder: isEmpty ? sentence(props.placeholder) : undefined, label: props.label, helperText: props.helperText, error: props.error, onMouseDown: onMouseDown, sx: {
            '& .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
                paddingRight: `calc(${paddingRight}px + ${counter.width}px)`
            }
        } }));
}
export default { renderInput };
